/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MPIStrictHttpResponse } from '../../mpi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientSearchModel } from '../../models/patient-search-model';
import { PatientSearchResultModel } from '../../models/patient-search-result-model';

export interface AdminSearchPost$Params {
      body?: PatientSearchModel
}

export function adminSearchPost(http: HttpClient, rootUrl: string, params?: AdminSearchPost$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<Array<PatientSearchResultModel>>> {
  const rb = new RequestBuilder(rootUrl, adminSearchPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MPIStrictHttpResponse<Array<PatientSearchResultModel>>;
    })
  );
}

adminSearchPost.PATH = '/Admin/Search';
